const routeToRouteNameMap = {
  "/sales/verhuur": "Verhuur",
  "/sales/e-commerce/products/10": "Producten Welda",
  "/sales/e-commerce/products/15": "Producten Welda Machinery",
  "/sales/e-commerce/products/70": "Producten AW-Tech",
  "/sales/planning": "Planning",
  "/companyweb": "Companyweb",
  "/sales/bezoeken": "Bezoeken",
  "/sales/margin-notes": "Marge-opmerkingen",
  "/sales/margin/manager": "Marge per leverancier",
  "/sales/margin": "Marges",
  "/sales/rode-prijslijst": "Rode prijslijst",
  "/sales/art-artmag-base": "Art-mag basis",
  "/AWTech/DBMapping": "DB Mapping",
  "/awtech/sales": "Verkoop onbehandeld",
  "/awtech/salesHandled": "Verkoop (alles)",
  "/internal/pricetags": "Price Tags",
  "/internal/stockCount": "Stock telling",
  "/notification/templates": "Sjablonen",
  "/notification/labels": "Etiketten",
  "/notification/scan": "Scannen",
  "/labels/templates": "Sjablonen",
  "/labels/print": "Print",
  "/link/add": "Link toevoegen",
  "/link/edit": "Linken wijzigen",
  "/link/supplier-docs/import": "DIAS-document importeren",
  "/link/productgroepen": "Productgroepen",
  "/manageEvents": "Overzicht",
  "/manageEvents/nieuw": "Nieuw evenement",
  "/manageEvents/scannen": "Scannen",
  "/manageEvents/addsubscription": "Nieuwe inschrijving",
  "/manageEvents/aanwezigheid": "Aanwezigheid",
  "/manageEvents/analytics": "Analytics",
  "/internal/AWTechUpdateFCThistoriek": "Dias FCT sync",
  "/management/datadrops": "Data Drops",
  "/management/openai/sales": "Open AI - Sales",
  "/management/kostenanalyseAWTech": "Kostenanalyse AW-Tech",
  "/offerteopvolging": "Offerteopvolging",
  "/offerteopvolging/manager": "Offerteopvolging manager",
  "/auto_off": "Auto. opvolging",
  "/org/presence": "Aanwezigheden",
  "/hr/badge-momenten": "Badge momenten",
  "/hr/aanwezigheid": "Aanwezigheid",
  "/service/mof": "Montage/opstart",
  "/service/todos": "Todo's",
  "/service/hrb": "Herstellingen",
  "/service/bestek-preview": "Bestekvoorbeeld",
  "/service/bestekken": "Bestekken opvolgen",
  "/service/analyse/uren": "Uren per technieker",
  "/service/calendar": "Planning technieker",
  "/service/old/mof": "Montage/opstart OLD",
  "/service/old/hrb": "Herstellingen OLD",
  "/service/planning": "Planning",
  "/finance/LopendeLVB": "Factuureerbaar",
  "/finance/openstaandedoc": "Openstaande Documenten",
  "/finance/artikel-rekeningen": "Artikel rekeningen",
  "/warehouse/dispatching": "Verzendingen",
  "/warehouse/eigen-diensten": "Eigen diensten kaart",
  "/warehouse/pickup": "Afhalingen",
  "/warehouse/asamco": "Asamco",
  "/warehouse/ecom": "Ecom",
  "/purchase/todo": "Nazicht",
  "/administration/sales": "Verkoop",
  "/marketing/content": "Content",
  "/marketing/links": "Links",
  "/marketing/banners": "Site Banners",
  "/marketing/promofolders": "Promo Folders",
  "/marketing/product-groups": "Product Groups",
  "/marketing/customer-product-queries": "Customer Product Queries",
  "/marketing/google-merchant": "Google Merchant",
  "/marketing/webshop-producten": "Webshop producten",
  "/marketing/discounts": "Discounts",
  "/marketing/tracking": "Tracking",
  "/marketing/carts": "Carts",
  "/marketing/orders": "Orders",
  "/marketing/clients": "Clients",
  "/admin/users": "users",
  "/admin/companies": "companies",
  "/admin/sessions": "sessions",
  "/admin/guests": "guests",
  "/admin/routes": "routes",
  "/admin/ai-prompts": "AI prompts",
  "/admin/sync-runs": "sync-runs",
  "/admin/login-monitor": "login-monitor",
  "/pkdb/products": "PKDB Productgroepen",
  "/pkdb/parameters": "PKDB Parameters",
  "/pkdb/questions": "PKDB Vragen",
  "/pkdb/links": "PKDB Links",
  "/pkdb/prompts": "PKDB Prompts",
  "/": "Dashboard",
};

const getRouteName = (path) => {
  // Prefer the longest matching key so nested routes (e.g. /manageEvents/scannen)
  // don't fall back to a shorter parent path (e.g. /manageEvents).
  const matchingKey = Object.keys(routeToRouteNameMap)
    .filter((key) => path.includes(key))
    .sort((a, b) => b.length - a.length)[0];
  return matchingKey ? routeToRouteNameMap[matchingKey] : null;
};

export default getRouteName;
